import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import img1 from "../../../assets/img/services/servicesOne/img-1.webp";
import logo1 from "../../../assets/img/services/servicesOne/card1.webp";
import logo2 from "../../../assets/img/services/servicesOne/card2.webp";
import logo3 from "../../../assets/img/services/servicesOne/card3.webp";
import logo4 from "../../../assets/img/services/servicesOne/card4.webp";

function ServicesOne() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
      <div className="servicesOne" id="services">
        <div className="servicesOneText">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("services_one_title")}
          </h1>
          <p className={`${isVisible ? "visible" : ""}`}>
            {t("services_one_text")}
          </p>
        </div>
        <div className="servicesOneImg">
          <img className={`${isVisible ? "visible" : ""}`} src={img1} alt="" />
        </div>
        <div className="servicesOneB" id="services">
            <div className="cards">
              <div className="card1 card">
                <img src={logo1} alt="" />
                <p>{t("services_one_card1")}</p>
              </div>
              <div className="card2 card">
                <img src={logo2} alt="" />
                <p>{t("services_one_card2")}</p>
              </div>
              <div className="card3 card">
                <img src={logo3} alt="" />
                <p>{t("services_one_card3")}</p>
              </div>
              <div className="card4 card">
                <img src={logo4} alt="" />
                <p>{t("services_one_card4")}</p>
              </div>
            </div>
          </div>
      </div>
    </VisibilitySensor>
  );
}

export default ServicesOne;
